@if (display) {
    <div class="file-preview">
        @if (!fileUrl) {
            <div class="loading-spinner fx-r fx-pc-c-c fx-as-stretch fx-f-grow">
                <mat-spinner></mat-spinner>
            </div>
        }
        @if (canPrev) {
            <button class="btn btn-prev" type="button" mat-mini-fab="mat-mini-fab" (click)="prevImage()">
                <mat-icon>chevron_left</mat-icon>
            </button>
        }
        @if (canNext) {
            <button class="btn btn-next" type="button" mat-mini-fab="mat-mini-fab" (click)="nextImage()">
                <mat-icon>chevron_right</mat-icon>
            </button>
        }
        <button class="btn-close" type="button" mat-mini-fab="mat-mini-fab" (click)="hideDialog()">
            <mat-icon>close</mat-icon>
        </button>
        @if (file.type === 'image') {
            <button class="btn btn-zoom" type="button" mat-mini-fab="mat-mini-fab" (click)="toggleZoom()">
                <mat-icon>{{ zoomScale > 1 ? 'zoom_out' : 'zoom_in' }}</mat-icon>
            </button>
        }
        <a class="btn btn-download" mat-mini-fab="mat-mini-fab" (click)="download(file)">
            <mat-icon>cloud_download</mat-icon>
        </a>
        <div class="doc-header">{{ file.name }}</div>
        @if (file.type === 'image') {
            <app-pinch-zoom #pinchzoom [height]="'100%'" [zoom-button]="false" [(scale)]="zoomScale">
                <img [src]="fileUrl" [alt]="file.name" />
            </app-pinch-zoom>
        }
        @if (file.type === 'pdf') {
            <object [data]="fileUrl" type="application/pdf" width="100%" height="100%">
                <p>Váš prohlížeč nepodporuje zobrazení PDF dokumentů.</p>
            </object>
        }
    </div>
}
